<!-- @format -->

<div class="notification-box" *transloco="let t">
  <div class="notification-box__info" [class.d-none]="!notificationContent.textContent && !notificationContent.children.length">
    @if (this.type !== "none") {
      <fudis-icon [icon]="icon" [color]="iconColor" />
    }
    <div class="notification-box__info__text" [class.notification-box__info__text--alert]="this.type === 'alert'" #notificationContent>
      <ng-content></ng-content>
      @if (infoClickAction.observed) {
        <sis-button [link]="true" (clicked)="infoClickAction.emit()">
          {{ t("SIS_COMPONENTS.STUDY.SHOW_INFO") }}
        </sis-button>
      }
    </div>
  </div>
  @if (primaryButtonText || secondaryButtonText || tertiaryButtonText) {
    <div class="notification-box__actions">
      <div class="notification-box__actions__buttons">
        <div class="float-right-preserve-tab-order">
          @if (secondaryButtonText) {
            @if (useFudisLink) {
              <a fudisLink [href]="'#'" [title]="t(secondaryButtonText)" (click)="secondaryClickAction.emit()" [size]="'inherit'"> </a>
            } @else {
              <fudis-button
                [size]="'small'"
                [variant]="'secondary'"
                [label]="t(secondaryButtonText)"
                (handleClick)="secondaryClickAction.emit()" />
            }
          }
          @if (primaryButtonText) {
            @if (useFudisLink) {
              <a fudisLink [href]="'#'" [title]="t(primaryButtonText)" (click)="primaryClickAction.emit()" [size]="'inherit'"> </a>
            } @else {
              <fudis-button
                [size]="'small'"
                [variant]="'primary'"
                [label]="t(primaryButtonText)"
                (handleClick)="primaryClickAction.emit()" />
            }
          }
          @if (tertiaryButtonText) {
            @if (useFudisLink) {
              <a fudisLink [href]="'#'" [title]="t(tertiaryButtonText)" (click)="tertiaryClickAction.emit()" [size]="'inherit'"> </a>
            } @else {
              <fudis-button
                class="tertiary-button"
                [size]="'small'"
                [variant]="'tertiary'"
                [label]="t(tertiaryButtonText)"
                (handleClick)="tertiaryClickAction.emit()" />
            }
          }
        </div>
      </div>
    </div>
  }
</div>
